/**
 * Licensed Materials - Property of ROOTCLOUD
 * THIS MODULE IS "RESTRICTED MATERIALS OF ROOTCLOUD"
 * (c) Copyright ROOTCLOUD Inc. 2021 All Rights Reserved
 *
 * The source code for this program is not published or
 * otherwise divested of its trade secrets
 */
/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-08-02 11:20:40
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-08-01 17:20:34
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;

// 根据客户查询对应角色
export function getCustomRole(params) {
  return request({
    url: `/api/v1/system/tenant/${params.id}/role-id`,
    method: "get",
    params: {}
  });
}

// 保存客户菜单信息
export function saveCustomRole(id, data) {
  return request({
    url: `${requestUrl}/role/${id}/menu`,
    method: "PATCH",
    data
  });
}
// 根据角色获取右侧菜单
export function getMenuByRoleId(id) {
  return request({
    url: `${requestUrl}/role/${id}`,
    method: "get"
  });
}

// 查询角色列表
const api = {
  // 分页获取角色
  getRoleList(params) {
    return request({
      url: `${requestUrl}/roles/page`,
      method: "get",
      params
    });
  },
  // 分页获取角色
  getList(params) {
    return request({
      url: `${requestUrl}/roles`,
      method: "get",
      params
    });
  },
  // 新增角色
  addRole(data) {
    return request({
      url: `${requestUrl}/role`,
      method: "post",
      data
    });
  },
  // 修改角色
  editRole(data) {
    return request({
      url: `${requestUrl}/role`,
      method: "put",
      data
    });
  },
  // 删除
  deleteRole(id) {
    return request({
      url: `${requestUrl}/role/${id}`,
      method: "delete"
    });
  },

  // 根据客户角色查询对应菜单
  getCustomRoleMenu(params) {
    return request({
      url: `${requestUrl}/menus`,
      method: "get",
      params
    });
  },

  // 根据角色获取右侧菜单
  getMenuByRoleId(id) {
    return request({
      url: `${requestUrl}/role/${id}`,
      method: "get"
    });
  },

  /**
   * @description: 保存角色菜单权限
   * @param {*} id，角色id
   * @param {*} ids
   * @return {*}
   */
  saveCustomRole(id, ids) {
    for (let i = 0; i < ids.length; i++) {
      if (ids[i].length === 0) {
        ids.splice(i, 1);
      }
    }
    const data = {
      operation: "REPLACE",
      keys: ids
    };
    return request({
      url: `${requestUrl}/role/${id}/menu`,
      method: "PATCH",
      data
    });
  },
  // 为用户分配角色
  roleAssignUser: (id, data) => request({
    url: `${requestUrl}/role/${id}/user`,
    method: "patch",
    data
  }),

  // 根据资源路径查询当前用户的资源信息
  getPermission(params) {
    return request({
      url: `${requestUrl}/resource-element/permission`,
      method: "get",
      params
    });
  },
  // 下发角色
  issueToOrgApi(params) {
    return request({
      url: `${requestUrl}/roles/distribute`,
      method: "get",
      params
    });
  },
  // 根据角色查询用户
  getRoleUserList(params) {
    return request({
      url: `${requestUrl}/user/by-role`,
      method: "get",
      params
    });
  }
};
export default api;
